import { AppDispatch } from '@/redux-store';
import { getOpenShiftsAssignments } from '@/redux-store/openShiftsAssignments/openShiftsAssignments.asyncActions.ts';
import { Location } from '@/types';
import { StandardDate } from '@/types/dates.types.ts';

export const getOpenShiftsAssignmentsAction =
  (from: StandardDate, to: StandardDate, locationIds: Location['id'][]) => (dispatch: AppDispatch) => {
    dispatch(getOpenShiftsAssignments({ from, to, locationIds }));
  };
